import React, { FC } from 'react';
import ErrorBoundary from './ErrorBoundary';
import { SIZE_FALLBACKS } from './constants';
import { InlineErrorFallbackSize } from './types';
import type { InlineErrorBoundaryProps } from './types';

const InlineErrorBoundary: FC<InlineErrorBoundaryProps> = ({ FallbackComponent, compact, size, ...rest }) => {
  // compact is a legacy alias for InlineErrorFallbackSize.Compact
  const Fallback = FallbackComponent ?? SIZE_FALLBACKS[size ?? (compact ? InlineErrorFallbackSize.Compact : InlineErrorFallbackSize.Full)];
  return <ErrorBoundary FallbackComponent={Fallback} {...rest} />;
};

export default InlineErrorBoundary;
